<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<div class="search-shoe-card">
    <h3 tabindex="0">{{shoe.name}}</h3>
    <img src="{{shoe.img}}" class="img-responsive" alt="picture of the {{shoe.name}}" width = "100%" tabindex="0">
    <ul tabindex="0">
        <li>Model: {{shoe.shoe}}</li>
        <li>Price: ${{shoe.retailPrice}}</li>
    </ul>
    <button *ngIf="this.showLikeButton" (click)="likeShoe();" id="like-button" class="fa fa-plus">Add to Favorites</button>
</div>